import React, {useEffect, useMemo, useState} from "react";
import {useLocation} from "react-router-dom";
import {useWrittenPrescriptionAdmission} from "../../../hook/request/ihioPrescriptionFilling";
import {
    IhioPrescriptionAdmissionType,
    ihioPrescriptionAdmissionTypeInitialValues, IhioWrittenPrescriptionInfoType
} from "../../../types/ihioPrescriptionFilling";
import NumberField from "../general/form/numberField";
import {SubmitHandler, useForm} from "react-hook-form";
import {general} from "../../../store/action";
import {connect} from "react-redux";
import WrittenPrescriptionInfoModal from "./writtenPrescriptionInfoModal";

type VisitTableLocationStateType = {
    willDoServiceMyself?: boolean
    nationalCode?: string
    trackingCode?: string
}

type PrescriptionFillingTrackingCodeCardProps = {
    handleShowModal: any;
}

const PrescriptionFillingTrackingCodeCard = ({
    handleShowModal,
}: PrescriptionFillingTrackingCodeCardProps) => {

    const location = useLocation();
    const visitTableLocationState = location?.state as VisitTableLocationStateType;

    const [prescriptionAdmissionData, setPrescriptionAdmissionData] = useState<IhioPrescriptionAdmissionType>(ihioPrescriptionAdmissionTypeInitialValues)

    const {
        control,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<IhioPrescriptionAdmissionType>({
        defaultValues: useMemo(() => prescriptionAdmissionData, [prescriptionAdmissionData]),
    });

    const writtenPrescriptionAdmissionRequest = useWrittenPrescriptionAdmission()

    useEffect(() => {
        if(visitTableLocationState?.willDoServiceMyself) {
            setPrescriptionAdmissionData({
                nationalCode: visitTableLocationState.nationalCode || '',
                trackingCode: visitTableLocationState.trackingCode || ''
            })
        }
    }, [visitTableLocationState]);

    useEffect(() => {
        if(writtenPrescriptionAdmissionRequest?.isSuccess) {
            handleShowModal('writtenPrescriptionInfoModal', {
                writtenPrescriptionData: writtenPrescriptionAdmissionRequest?.data?.data?.result,
                prescriptionAdmissionData: prescriptionAdmissionData
            })
        }
    }, [writtenPrescriptionAdmissionRequest?.isSuccess]);

    useEffect(() => {
        reset(prescriptionAdmissionData);
    }, [prescriptionAdmissionData]);



    const handleSubmitAdmission: SubmitHandler<IhioPrescriptionAdmissionType> = (data) => {
        const { nationalCode, trackingCode } = data;
        setPrescriptionAdmissionData(data);
        writtenPrescriptionAdmissionRequest.mutate({
            nationalCode,
            trackingCode,
        });
    }


    return(
        <div
            className="w-100 mx-auto bg-white shadow-none border border-gray-300 px-md-5 px-3 py-4 rounded-4 mb-3">
            <form onSubmit={handleSubmit(handleSubmitAdmission)}>
                <div className="row">
                    <div className="col-12 col-md-6 px-4">
                        <div className="form-group mb-4 pb-1">
                            {/* <label className="inp-lbl mr-2" htmlFor="username">نام کاربری</label> */}
                            <NumberField
                                name="nationalCode"
                                placeholder="کد ملی"
                                className="ltr plc-right font-en"
                                control={control}
                                error={errors}
                                allowLeadingZeroes
                                isNumericString
                                maxLength={11}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-6 px-4">
                        <div className="form-group mb-4 pb-1">
                            {/* <label className="inp-lbl mr-2" htmlFor="username">نام کاربری</label> */}
                            <NumberField
                                name="trackingCode"
                                placeholder="کد رهگیری"
                                className="ltr plc-right font-en"
                                control={control}
                                error={errors}
                                allowLeadingZeroes
                                isNumericString
                                maxLength={11}
                            />
                        </div>
                    </div>
                        <div className="col-12 px-4 d-flex justify-content-end">
                            <div className="w-100 d-flex form-group mb-2 mr-auto mt-auto pb-1">
                                <button
                                    type='submit'
                                    className="btn btn-primary w-100 rounded d-flex align-items-center justify-content-center font-16 fw-bold px-4 p-2"
                                >
                                    بررسی و پذیرش
                                </button>
                            </div>
                        </div>
                    </div>
            </form>
            <WrittenPrescriptionInfoModal/>
        </div>
    )
}


const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionFillingTrackingCodeCard);
